<div class="mt-4">
  <div class="d-flex justify-content-between">
    <div>
      <searcher
        [label]="'Buscar Locaciones'"
        (onChange)="search($event)"
        [showLoading]="showLoading"
      ></searcher>
    </div>
    <div>
      <button (click)="create()" class="create-button" *ngIf="canCreate">
        Crear Locación
      </button>
    </div>
  </div>
  <app-table
    [data]="locationsList"
    [displayedColumns]="columns"
    [columnsNames]="columnsNames"
    [total]="total"
    [offset]="offset"
    [limit]="limit"
    (update)="update($event)"
    (delete)="delete($event)"
    (onPageChange)="handlePageChange($event)"
  ></app-table>
</div>
